import { lazy } from 'react';
import { Route } from 'react-router-dom';

import { RequireRole } from '@/core/permissions';

const SettingsPage = lazy(() =>
  import('./pages/SettingsPage').then(m => ({ default: m.SettingsPage }))
);

/** Admin-gated example route (usePermission/RequireRole — UX gate only; the
 *  server enforces via HasSchoolRole). */
export const settingsRoutes = (
  <Route element={<RequireRole roles={['admin']} />}>
    <Route path="/settings" element={<SettingsPage />} />
  </Route>
);
